import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivityNotification } from '../../types/activity-notification';
import { OeAppService } from '../../oe-app.service';

@Component({
  selector: 'lp2-activity-modal-notification',
  templateUrl: './activity-modal-notification.component.html',
  styleUrls: ['./activity-modal-notification.component.scss'],
})
export class ActivityModalNotificationComponent {
  notification: ActivityNotification;

  gamificationS3Url = `//${this.oeApp.s3BucketHost()}/gamification`;

  constructor(
    private ngbActiveModal: NgbActiveModal,
    private oeApp: OeAppService
  ) {}

  close() {
    this.ngbActiveModal.close();
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/activity-notification/activity-modal-notification/activity-modal-notification.component.ts